module.exports = __webpack_public_path__ + "static/media/top_19.712b8166.svg";